import * as types from "./actionTypes";

export function toggleLoader(loading = false) {
  return { type: types.TOGGLE_LOADER, loading };
}
